<template>
    <b-container>
        <b-row>
            <b-col lg="6" md="8" class="about">
                <img src="../assets/img/bizpro-logo.svg" alt="Bizpro" style="width: 60%;">
                <p>
                    &nbsp;
                </p>
                <p>
                    We develop and deliver different tailored web-related IT and graphic design solutions for corporate and startups.
                </p>
                <p>
                    Since our foundation in 2007, our intention has never been the massive creation of websites or applications, but creating original, creative and business-powered web-based applications, including E-Commerce, E-Learning and also CRM-integrated solutions that respond to higher business interests and purposes.
                </p>
            </b-col>
            <b-col lg="6" md="4" class="image">
                <img src="../assets/img/bizpro.svg" alt="Bizpro">
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
  export default {
    name: 'Bizpro',
  }
</script>

<style scoped>
    .about {
        text-align: center;
    }
</style>